import React, { useEffect, useState } from "react";
import * as S from "../../style/StyleComponentSection";
import { useSelector } from "react-redux";
import { RootState } from "../../redux/Store";
import Pagination from "../Utility/Pagination";
import { get_notice_select } from "../../Axios";
import { useNavigate } from "react-router-dom";

interface NoticeObject {
  ablack_notice_ID: number;
  ablack_notice_title: string;
  ablack_notice_registe: string;
  ablack_notice_top_status: number;
};

const Notice: React.FC = () => {
  const navigate = useNavigate();
  const customerData = useSelector((state: RootState) => state.customerData);
  const [noticeList, setNoticeList] = useState<NoticeObject[]>([]);
  const [totalNotice, setTotalNotice] = useState<number>(0);
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    get_notice_select(customerData.customer_ID, page).then(result => {
      setNoticeList(result.rows);
      setTotalNotice(result.rows_total);
    })
  }, [customerData.customer_ID, page]);

  const handlePage = (page: number) => {
    setPage(page);
  };

  return (
    <S.SectionContainer>
      <S.SectionWidth $width={1080}>
        <S.SectionTitleBox>
          <h1>공지사항</h1>
          <h3>A.Black의 공지사항을 확인할 수 있습니다.</h3>
        </S.SectionTitleBox>

        <S.ReservationTableHead className="mt-[50px]">
          <div className="w-[110px] pr-[27px]">번호</div>
          <div className="">제목</div>
          <div className="w-[110px]">등록일</div>
        </S.ReservationTableHead>

        <div>
          {noticeList.map((tmp) =>
            <S.ReservationTableBody
              key={tmp.ablack_notice_ID}
              $withBtn={false}
              onClick={() => {
                navigate('/notice_select_one', { state : {ablack_notice_ID : tmp.ablack_notice_ID} });
              }}
            >
              <div className="w-[110px] pr-[27px]">{tmp.ablack_notice_ID}</div>
              <div className="w-[]">{tmp.ablack_notice_title}</div>
              <div className="w-[110px]">{tmp.ablack_notice_registe.slice(0, 10)}</div>
            </S.ReservationTableBody>
          )}
        </div>

        <Pagination totalCount={totalNotice} handlePage={handlePage} listCount={10} page={page} />

      </S.SectionWidth>
    </S.SectionContainer>
  )
};

export default Notice;